import React from "react";
import { Form, Input, Button, message } from 'antd';

const ChangePasswordForm = () => {
    const [form] = Form.useForm();

    const onFinish = (values) => {
        if (values.newPassword !== values.confirmPassword) {
            message.error('Password konfirmasi tidak cocok');
            return;
        }

        const user = JSON.parse(localStorage.getItem('user')) || {};

        if (user.password && values.oldPassword !== user.password) {
            message.error('Password lama tidak sesuai');
            return;
        }

        user.password = values.newPassword;
        localStorage.setItem('user', JSON.stringify(user));
        message.success('Password berhasil diperbaharui');
        form.resetFields();
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
                label="Password Lama"
                name="oldPassword"
                rules={[{ required: true, message: 'Password lama harus diisi' }]}>
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Password Baru"
                    name="newPassword"
                    rules={[
                        { required: true, message: 'Password baru harus diisi' },
                        { min: 6, message: 'Password minimal 6 karakter' },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Konfirmasi Password Baru"
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        { required: true, message: 'Harap konfirmasi password baru' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Password konfirmasi tidak cocok'));
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Ubah Password
                    </Button>
                </Form.Item>
        </Form>
    );
};

export default ChangePasswordForm;